import {useAppSelector} from '@/redux-store/store';
import {GroupData} from '@/types/group';
import {
  isDocumentCompanyRoleHealthManager,
  isUserDocumentManager
} from '@/utils';
import {Button, Grid} from '@mui/material';
import {useTranslation} from 'react-i18next';

interface GroupDetailsButtonsProps {
  selectedGroup: GroupData;
  handleDeleteConfirmation: (e: React.MouseEvent<HTMLButtonElement>) => void;
  handleGroupLeaveClick: () => void;
  handleGroupJoinClick: () => void;
  handleGroupEditButtonClick: () => void;
  isTrainerInSjOne?: boolean;
}

const GroupDetailsButtons: React.FC<GroupDetailsButtonsProps> = ({
  selectedGroup,
  handleDeleteConfirmation,
  handleGroupLeaveClick,
  handleGroupJoinClick,
  handleGroupEditButtonClick,
  isTrainerInSjOne
}) => {
  const {t} = useTranslation();

  const userInfo = useAppSelector((state) => state.userInfos.userInfos);

  const {isUserHealthManager} = useAppSelector((state) => state.auth);

  const isHealthManagerGroup =
    selectedGroup && isDocumentCompanyRoleHealthManager(selectedGroup);

  const companyGroupAndUserHealthManager =
    isUserHealthManager && isHealthManagerGroup;

  const isUserManager = isUserDocumentManager(selectedGroup, userInfo);
  const isMember =
    selectedGroup.members.findIndex((m) => m._id === userInfo._id) >= 0;

  const allowedToJoin =
    !isTrainerInSjOne ||
    (isTrainerInSjOne && (isHealthManagerGroup || isUserManager));

  return (
    <Grid container spacing={2} sx={{marginTop: 2}}>
      {isUserManager || companyGroupAndUserHealthManager ? (
        <>
          <Grid
            item
            xs={12}
            sm={4}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mb: {xs: 1, sm: 0}
            }}
          >
            <Button
              variant="contained"
              color="secondary"
              onClick={handleDeleteConfirmation}
              sx={{width: {xs: '100%', sm: '65%'}}}
            >
              {t('delete')}
            </Button>
          </Grid>
          <Grid
            item
            xs={12}
            sm={4}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mb: {xs: 1, sm: 0}
            }}
          >
            <Button
              variant="contained"
              color="secondary"
              onClick={() => handleGroupEditButtonClick()}
              sx={{width: {xs: '100%', sm: '65%'}}}
            >
              {t('edit')}
            </Button>
          </Grid>
        </>
      ) : null}

      <Grid
        item
        xs={12}
        sm={isUserManager || companyGroupAndUserHealthManager ? 4 : 12}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          mb: {xs: 1, sm: 0}
        }}
      >
        {isMember ? (
          <Button
            variant="contained"
            color="secondary"
            onClick={handleGroupLeaveClick}
            sx={{
              width: {
                xs: '100%',
                sm:
                  isUserManager || companyGroupAndUserHealthManager
                    ? '65%'
                    : '200px'
              },
              mb: {xs: 1, sm: 0}
            }}
          >
            {t('group_leave')}
          </Button>
        ) : allowedToJoin ? (
          <Button
            variant="contained"
            color="secondary"
            onClick={handleGroupJoinClick}
            sx={{
              width: {
                xs: '100%',
                sm:
                  isUserManager || companyGroupAndUserHealthManager
                    ? '65%'
                    : '200px'
              },
              mb: {xs: 1, sm: 0}
            }}
          >
            {t('group_join')}
          </Button>
        ) : null}
      </Grid>
    </Grid>
  );
};

export default GroupDetailsButtons;
